var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"description-main-container"},_vm._l((_vm.agencyDescriptionsData),function(descriptionData,index){return _c('div',{key:index},[_c('p',{domProps:{"innerHTML":_vm._s(descriptionData.attributes.description)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }